import React, { useState, useEffect } from 'react';
import { getMovieDetails, getCasting, getStreamingPlatforms, getTrailer } from '../utils/api';
import './FilmDetails.css';
import BlurayComponent from './BlurayComponent';

const FilmDetails = ({ media_type, film_id }) => {
  const [movieDetails, setMovieDetails] = useState(null);
  const [castData, setCastData] = useState([]);
  const [platforms, setPlatforms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [trailerKey, setTrailerKey] = useState(null);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        setLoading(true);
        const [details, cast, streamingPlatforms, trailer] = await Promise.all([
          getMovieDetails(media_type, film_id),
          getCasting(media_type, film_id),
          getStreamingPlatforms(media_type, film_id),
          getTrailer(media_type, film_id)
        ]);
        
        setTrailerKey(trailer);
        setMovieDetails(details);
        setPlatforms(streamingPlatforms);
        setCastData(cast);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (media_type && film_id) {
      fetchDetails();
    }
  }, [media_type, film_id]);

  if (loading) {
    return <div className="loading">Chargement...</div>;
  }

  if (error) {
    return <div className="error">Erreur: {error}</div>;
  }

  if (!movieDetails) {
    return <div className="error">Aucune information disponible</div>;
  }

  return (
    <div className="film-details">
      <div className="summary-details">
      <h3>Summary</h3>
        <p>{movieDetails.overview || 'Non disponible'}</p>
        <p><strong>Release: </strong> {movieDetails.release_date || movieDetails.first_air_date || 'Non -'} - {movieDetails.runtime || movieDetails.episode_run_time?.[0] || '-'} minutes</p>
      </div>

      <div className="cast-section">
        <h3>Casting</h3>
        <div className="cast-grid">
          {castData.map((actor) => (
            <div key={actor.id} className="cast-item">
              <img 
                src={actor.profile_path ? 
                  `https://image.tmdb.org/t/p/w185${actor.profile_path}` : 
                  'https://via.placeholder.com/185x278?text=No+Image'
                } 
                alt={actor.name}
              />
              <div className="cast-info">
                <span className="actor-name">{actor.name}</span>
                <span className="character-name">{actor.character}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
          <h3>Platforms</h3>
      <div className="platforms-list">
        {platforms.length > 0 ? (
          platforms.map((platform, index) => (
            <div key={index} className="platform-item">
              <img src={platform.logo} alt={platform.name} />
              <span>{platform.name}</span>
            </div>
          ))
        ) : (
          <p>Non disponible en streaming pour le moment</p>
        )}
      </div>

      {trailerKey && (
        <div className="trailer-section">
          <h3>Trailer</h3>
          <div className="trailer-container">
            <iframe
              src={`https://www.youtube.com/embed/${trailerKey}`}
              title="Trailer"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}

      <div className="friends-ratings-section">
        <h3>Notes des amis</h3>
        <div className="ratings-only">
          <BlurayComponent 
            item={{
              film_id: film_id,
              media_type: media_type,
              title: movieDetails.title || movieDetails.name,
              poster_path: movieDetails.poster_path,
              year: new Date(movieDetails.release_date || movieDetails.first_air_date).getFullYear(),
              genre_names: movieDetails.genres?.map(g => g.name),
              director: movieDetails.credits?.crew?.find(c => c.job === "Director")?.name,
              vote_average: movieDetails.vote_average,
            }}
            showButtons={false}
            showScorings={true}
            showScoreTinder={false}
          />
        </div>
      </div>
    </div>
  );
};

export default FilmDetails;
